import { WorkflowDashboard } from '@/components/WorkflowDashboard';

export default function Dashboard() {
  return <WorkflowDashboard />;
}
